import { ProductsBasket } from '@/type/basket'

/**
 * Ligne de panier posée par le parcours PLV (bouton « Commander » de l'extranet) : elle porte
 * le budget de campagne `storeBagProgramPharmacyBudgetId`, seul lien entre la commande et la
 * participation de la pharmacie. Toute action qui recrée la ligne sans cette marque (quantité
 * libre, mise de côté puis reprise) détache la commande de la campagne.
 */
const isStoreBagLine = (product: Pick<ProductsBasket, 'extra'> | null | undefined): boolean =>
  (product?.extra?.storeBagProgramPharmacyBudgetId?.length ?? 0) > 0

export default isStoreBagLine
